import React from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_CURRENCY, PRODUCT_PRICE } from '../data/config';
import { trackPixel } from '../utils/pixel';
type CtaButtonProps = {
  children: React.ReactNode;
  mode: 'checkout' | 'scroll';
  subtext?: string;
  className?: string;
};
export function CtaButton({
  children,
  mode,
  subtext,
  className = 'max-w-md'
}: CtaButtonProps) {
  const isCheckout = mode === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={() => isCheckout && trackPixel('InitiateCheckout', {
    value: PRODUCT_PRICE,
    currency: PRODUCT_CURRENCY
  })} className={`mx-auto flex min-h-[52px] w-full flex-col items-center justify-center rounded-md bg-amber-400 px-4 py-2.5 text-center text-blue-950 shadow-[0_4px_0_theme(colors.amber.700)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-amber-300 active:translate-y-0.5 active:shadow-[0_2px_0_theme(colors.amber.700)] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-500/40 ${className}`} data-id="element-24" data-mp="qi7g7rwm3sax">
      <span className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase leading-tight sm:text-base md:text-lg" data-id="element-25" data-mp="39y7x1z1ax861">
        <ZapIcon className="h-[18px] w-[18px] shrink-0 fill-blue-950" strokeWidth={2.5} aria-hidden data-id="element-26" data-mp="3ex2rxzcjmn6i" />
        <span data-id="element-27" data-mp="3jyibto2zinnb">{children}</span>
      </span>
      {subtext && <span className="mt-1 text-xs font-semibold leading-tight" data-id="element-28" data-mp="3owa0884f7rmr">{subtext}</span>}
    </a>;
}